(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noir-discount-pill"] && !Shopify.designMode) return;
  try {
    (() => {
    const pill = document.querySelector('[data-noir-discount-pill]');
    const openButton = pill?.querySelector('[data-noir-discount-open]');
    const suggestion = document.querySelector('[data-noir-discount-suggestion]');
    const suggestionOpenButton = suggestion?.querySelector('[data-noir-discount-suggestion-open]');
    const suggestionDismissButton = suggestion?.querySelector('[data-noir-discount-suggestion-dismiss]');
    const suggestionTimerProgress = suggestion?.querySelector('.noir-discount-suggestion__timer-progress');
    if (!pill || !openButton || !suggestion || !suggestionOpenButton || !suggestionDismissButton) return;

    const suggestionStorageKey = 'noir-discount-scroll-suggestion-seen';
    const scrollSuggestionThreshold = 120;
    const suggestionAutoHideDelay = 10000;
    const suggestionTimerCircumference = 119.38;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let manualFormRequested = false;
    let manualFormOpenSequence = 0;
    let manualFormScrollSequence = 0;
    let suggestionVisible = false;
    let suggestionInteractionActive = false;
    let suggestionRemainingMs = suggestionAutoHideDelay;
    let suggestionAutoHideDeadline = 0;
    let suggestionAutoHideTimer;
    let suggestionCountdownFrame;
    let suggestionHideTimer;

    const hasSeenSuggestion = () => {
      try {
        return window.sessionStorage.getItem(suggestionStorageKey) === '1';
      } catch (error) {
        return false;
      }
    };

    const markSuggestionSeen = () => {
      try {
        window.sessionStorage.setItem(suggestionStorageKey, '1');
      } catch (error) {
        return undefined;
      }
    };

    const stopSuggestionCountdown = () => {
      if (suggestionCountdownFrame) window.cancelAnimationFrame(suggestionCountdownFrame);
      suggestionCountdownFrame = undefined;
    };

    const renderSuggestionCountdown = () => {
      if (!suggestionTimerProgress) return;

      const progress = Math.min(
        Math.max(1 - suggestionRemainingMs / suggestionAutoHideDelay, 0),
        1
      );
      suggestionTimerProgress.style.strokeDashoffset = String(
        (progress * suggestionTimerCircumference).toFixed(2)
      );
    };

    const clearSuggestionAutoHideTimers = () => {
      window.clearTimeout(suggestionAutoHideTimer);
      stopSuggestionCountdown();
      suggestionAutoHideDeadline = 0;
    };

    const refreshSuggestionCountdown = (now) => {
      if (!suggestionAutoHideDeadline) return;

      suggestionRemainingMs = Math.max(0, suggestionAutoHideDeadline - now);
      renderSuggestionCountdown();

      if (
        suggestionRemainingMs > 0 &&
        suggestionVisible &&
        !suggestionInteractionActive
      ) {
        suggestionCountdownFrame = window.requestAnimationFrame(refreshSuggestionCountdown);
      }
    };

    const startSuggestionAutoHide = () => {
      if (!suggestionVisible || suggestionInteractionActive) return;

      window.clearTimeout(suggestionAutoHideTimer);
      suggestionAutoHideDeadline = performance.now() + suggestionRemainingMs;
      stopSuggestionCountdown();
      if (!reducedMotion) {
        suggestionCountdownFrame = window.requestAnimationFrame(refreshSuggestionCountdown);
      }
      suggestionAutoHideTimer = window.setTimeout(() => {
        suggestionRemainingMs = 0;
        renderSuggestionCountdown();
        hideSuggestion();
      }, suggestionRemainingMs);
    };

    const hideSuggestion = () => {
      suggestionVisible = false;
      suggestionInteractionActive = false;
      clearSuggestionAutoHideTimers();
      suggestion.classList.remove('is-visible', 'is-counting');
      suggestion.setAttribute('aria-hidden', 'true');
      window.clearTimeout(suggestionHideTimer);
      suggestionHideTimer = window.setTimeout(() => {
        if (!suggestionVisible) suggestion.hidden = true;
      }, 240);
    };

    const showSuggestion = () => {
      if (suggestionVisible || manualFormRequested || hasSeenSuggestion()) return;

      markSuggestionSeen();
      suggestionVisible = true;
      suggestionRemainingMs = suggestionAutoHideDelay;
      suggestion.hidden = false;
      suggestion.setAttribute('aria-hidden', 'false');
      suggestion.classList.add('is-counting');
      if (suggestionTimerProgress) {
        suggestionTimerProgress.style.strokeDashoffset = '0';
        suggestionTimerProgress.getBoundingClientRect();
      }
      startSuggestionAutoHide();
      window.requestAnimationFrame(() => {
        if (suggestionVisible) suggestion.classList.add('is-visible');
      });
    };

    const styleText = `
      #app-embed[data-current-step="form"],
      #app-embed[data-current-step="tease"] {
        position: fixed !important;
        z-index: 1102 !important;
        inset: 0 !important;
        width: 100vw !important;
        max-width: none !important;
        height: 100vh !important;
        min-height: 0 !important;
        box-sizing: border-box !important;
        overflow: visible !important;
        transform: none !important;
        background: transparent !important;
        box-shadow: none !important;
        filter: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        pointer-events: none !important;
      }

      :host([data-noir-discount-form-requested]) #app-embed[data-current-step="form"] {
        opacity: 1 !important;
        visibility: visible !important;
      }

      #app-embed[data-current-step="form"] dialog,
      #app-embed[data-current-step="tease"] dialog {
        inset: 0 !important;
        width: 100vw !important;
        max-width: none !important;
        height: 100vh !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        filter: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        pointer-events: none !important;
      }

      #app-embed[data-current-step="form"] dialog::backdrop,
      #app-embed[data-current-step="tease"] dialog::backdrop {
        background: transparent !important;
        background-color: transparent !important;
        filter: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
      }

      #app-embed[data-current-step="form"] [class*="_overlay_"],
      #app-embed[data-current-step="form"] [class*="_backdrop_"],
      #app-embed[data-current-step="form"] [class*="_overlayBackground_"],
      #app-embed[data-current-step="form"] [data-testid*="overlay"],
      #app-embed[data-current-step="form"] [data-testid*="backdrop"],
      #app-embed[data-current-step="tease"] [class*="_overlay_"],
      #app-embed[data-current-step="tease"] [class*="_backdrop_"],
      #app-embed[data-current-step="tease"] [class*="_overlayBackground_"],
      #app-embed[data-current-step="tease"] [data-testid*="overlay"],
      #app-embed[data-current-step="tease"] [data-testid*="backdrop"] {
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        filter: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        opacity: 1 !important;
        pointer-events: none !important;
      }

      #app-embed [data-testid="form-teaser"],
      [data-testid="form-teaser"],
      [class*="_teaserContainer_"] {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 1px !important;
        min-width: 1px !important;
        height: 1px !important;
        min-height: 1px !important;
        padding: 0 !important;
        border: 0 !important;
        box-shadow: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        overflow: hidden !important;
        clip-path: inset(50%) !important;
      }

      :host([data-noir-discount-form-requested]) [class*="_overlay_"],
      :host([data-noir-discount-form-requested]) [class*="_backdrop_"],
      :host([data-noir-discount-form-requested]) [class*="_overlayBackground_"],
      :host([data-noir-discount-form-requested]) [data-testid*="overlay"],
      :host([data-noir-discount-form-requested]) [data-testid*="backdrop"] {
        background: transparent !important;
        background-color: transparent !important;
        box-shadow: none !important;
        filter: none !important;
        backdrop-filter: none !important;
        -webkit-backdrop-filter: none !important;
        opacity: 1 !important;
        pointer-events: none !important;
      }

      #app-embed[data-current-step="form"] [class*="_overlayBackground_"],
      #app-embed[data-current-step="tease"] [class*="_overlayBackground_"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        animation: none !important;
      }

      #app-embed[data-current-step="form"] {
        --forms-accent-color: #121212 !important;
        --forms-accent-color-hovered-modifier: #1212121a !important;
        --forms-overlay-background-color: transparent !important;
        --forms-overlay-background-opacity: 0 !important;
        --forms-discount-code-color: #121212 !important;
        --link-text-color: #121212 !important;
        --heading-text-color: #121212 !important;
        --button-text-color: #ffffff !important;
        --button-background-color: #121212 !important;
        --button-background-color-hovered-modifier: opacity(82%) !important;
        --button-close-background-color: #ffffff !important;
        --button-close-color: #121212 !important;
        --button-border: 1px solid #121212 !important;
        --button-border-radius: var(--noir-control-radius, 1.3rem) !important;
        --container-border-radius: var(--noir-control-radius, 1.3rem) !important;
        --form-field-border: 0 0 0 1px rgba(18, 18, 18, 0.24) !important;
        --form-field-border-focused: 0 0 0 2px #121212 !important;
        --form-field-border-radius: var(--noir-control-radius, 1.3rem) !important;
        --forms-body-font: normal 400 14px var(--font-body-family, 'Plus Jakarta Sans', sans-serif) !important;
        --forms-heading-font: normal 500 22px var(--font-heading-family, 'Plus Jakarta Sans', sans-serif) !important;
        --form-text-color: #202020 !important;
        --form-placeholder-color: rgba(32, 32, 32, 0.52) !important;
        --spacing-size-y: 16px !important;
        --spacing-size-x: 18px !important;
        --app-embed-padding-y: 18px !important;
        --app-embed-padding-x: 18px !important;
        --forms-heading-font-size: 18px !important;
        --heading-font-size: 18px !important;
      }

      :host(:not([data-noir-discount-form-requested])) #app-embed[data-current-step="form"] {
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      #app-embed[data-current-step="form"] section[class*="_formContainer_"],
      #app-embed[data-current-step="tease"] section[class*="_formContainer_"] {
        position: fixed !important;
        top: 50% !important;
        right: auto !important;
        bottom: auto !important;
        left: calc(1.25rem + 7.25rem + 1rem) !important;
        width: min(23rem, calc(100vw - 11rem)) !important;
        max-width: calc(100vw - 11rem) !important;
        height: auto !important;
        max-height: min(70vh, 40rem) !important;
        margin: 0 !important;
        box-sizing: border-box !important;
        overflow-y: auto !important;
        transform: translateY(-50%) translateX(-0.75rem) scale(0.96) !important;
        transform-origin: left center !important;
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        transition:
          opacity 220ms cubic-bezier(0.23, 1, 0.32, 1),
          transform 220ms cubic-bezier(0.23, 1, 0.32, 1),
          visibility 0s linear 220ms !important;
        border-radius: var(--noir-control-radius, 1.3rem) !important;
      }

      :host([data-noir-discount-form-requested]) #app-embed[data-current-step="form"] section[class*="_formContainer_"] {
        transform: translateY(-50%) translateX(0) scale(1) !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        transition-delay: 0s !important;
      }

      #app-embed[data-current-step="form"] [class*="_formHeader_"] h2,
      #app-embed[data-current-step="form"] [class*="_formHeader_"] [class*="_textHeading_"] {
        width: calc(100% - 48px) !important;
        max-width: calc(100% - 48px) !important;
        margin-right: auto !important;
        margin-left: auto !important;
      }

      #app-embed[data-current-step="form"] button[type="submit"] {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        text-align: center !important;
        vertical-align: middle !important;
        box-sizing: border-box !important;
        min-height: 44px !important;
        height: 44px !important;
        padding: 0 2.5rem !important;
        border: 0 !important;
        border-radius: var(--noir-control-radius, 1.3rem) !important;
        background: #121212 !important;
        background-image: none !important;
        color: #ffffff !important;
        font: inherit !important;
        font-size: 15px !important;
        font-weight: 600 !important;
        letter-spacing: 0.1rem !important;
        line-height: 1.2 !important;
        outline: none !important;
        box-shadow: none !important;
        transition: background-color 180ms ease, color 180ms ease, transform 180ms ease !important;
      }

      #app-embed[data-current-step="form"] button[type="submit"]:hover {
        background: #2a2a2a !important;
        color: #ffffff !important;
        transform: translateY(-1px);
      }

      #app-embed[data-current-step="form"] button[type="submit"]:focus-visible {
        outline: 2px solid #121212 !important;
        outline-offset: 3px !important;
      }

      #app-embed[data-current-step="form"] input,
      #app-embed[data-current-step="form"] textarea,
      #app-embed[data-current-step="form"] select {
        border-radius: var(--noir-control-radius, 1.3rem) !important;
        box-shadow: 0 0 0 1px rgba(18, 18, 18, 0.24) !important;
      }

      #app-embed[data-current-step="form"] input,
      #app-embed[data-current-step="form"] select {
        box-sizing: border-box !important;
        height: 44px !important;
        min-height: 44px !important;
        padding: 0 14px !important;
        line-height: 1.2 !important;
      }

      #app-embed[data-current-step="form"] input:focus,
      #app-embed[data-current-step="form"] textarea:focus,
      #app-embed[data-current-step="form"] select:focus {
        box-shadow: 0 0 0 2px #121212 !important;
        outline: none !important;
      }

      #app-embed[data-current-step="form"] [class*="_formCloseButton_"],
      #app-embed[data-current-step="form"] button[aria-label*="lose"],
      #app-embed[data-current-step="form"] button[title*="lose"] {
        display: grid !important;
        width: 32px !important;
        height: 32px !important;
        padding: 0 !important;
        place-items: center !important;
        position: absolute !important;
        top: 10px !important;
        right: 10px !important;
        bottom: auto !important;
        left: auto !important;
        z-index: 2 !important;
        margin: 0 !important;
        transform: none !important;
        border: 1px solid rgba(18, 18, 18, 0.18) !important;
        border-radius: 50% !important;
        background: #ffffff !important;
        color: #121212 !important;
      }

      #app-embed[data-current-step="form"] [class*="_formCloseButton_"]:hover,
      #app-embed[data-current-step="form"] button[aria-label*="lose"]:hover,
      #app-embed[data-current-step="form"] button[title*="lose"]:hover {
        background: #f1f1f1 !important;
      }

      #app-embed[data-current-step="form"] section[class*="_formContainer_"] {
        width: min(560px, calc(100vw - 11rem)) !important;
        max-width: calc(100vw - 11rem) !important;
        max-height: min(64vh, 34rem) !important;
      }

      #app-embed[data-current-step="form"] section[class*="_formContainer_"][class*="_grid_"] {
        grid-template-columns: 2fr 3fr !important;
        max-width: 100% !important;
      }

      #app-embed[data-current-step="form"] [class*="_formHeader_"] h2,
      #app-embed[data-current-step="form"] [class*="_formHeader_"] [class*="_textHeading_"] {
        font-size: 18px !important;
        line-height: 1.16 !important;
      }

      #app-embed[data-current-step="form"] textarea {
        min-height: 44px !important;
        padding: 10px 14px !important;
      }

      @media only screen and (max-width: 749px) {
        #app-embed[data-current-step="form"],
        #app-embed[data-current-step="tease"] {
          height: 100dvh !important;
        }

        #app-embed[data-current-step="form"] {
          --spacing-size-y: 10px !important;
          --spacing-size-x: 14px !important;
          --app-embed-padding-y: 12px !important;
          --app-embed-padding-x: 14px !important;
          --forms-heading-font-size: 17px !important;
          --heading-font-size: 17px !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"],
        #app-embed[data-current-step="tease"] section[class*="_formContainer_"] {
          top: auto !important;
          right: 0.75rem !important;
          bottom: calc(1rem + env(safe-area-inset-bottom) + 9.5rem) !important;
          left: 0.75rem !important;
          width: auto !important;
          max-width: none !important;
          transform: translateY(0) scale(1) !important;
          transform-origin: center bottom !important;
        }

        :host([data-noir-discount-form-requested]) #app-embed[data-current-step="form"] section[class*="_formContainer_"] {
          transform: translateY(0) scale(1) !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"] {
          width: auto !important;
          max-width: none !important;
          height: auto !important;
          max-height: 64dvh !important;
          min-width: 0 !important;
          min-height: 0 !important;
          overflow-y: auto !important;
          overscroll-behavior: contain !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"][class*="_grid_"] {
          grid-template-columns: 1fr !important;
          grid-template-rows: 112px auto !important;
          max-width: none !important;
          min-width: 0 !important;
          min-height: 0 !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"][class*="_grid_"] > :first-child {
          height: 112px !important;
          min-height: 0 !important;
          overflow: hidden !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"][class*="_grid_"] > :first-child img {
          width: 100% !important;
          height: 100% !important;
          max-height: 100% !important;
          object-fit: cover !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"][class*="_grid_"] > :nth-child(2) {
          min-height: 0 !important;
          overflow: visible !important;
        }

        #app-embed[data-current-step="form"] [class*="_gridItemContent_"] {
          min-width: 0 !important;
          min-height: 0 !important;
          padding: 12px 16px 14px !important;
        }

        #app-embed[data-current-step="form"] [class*="_formHeader_"] h2,
        #app-embed[data-current-step="form"] [class*="_formHeader_"] [class*="_textHeading_"] {
          font-size: 17px !important;
          line-height: 1.12 !important;
        }
      }

      @media (prefers-reduced-transparency: reduce) {
        #app-embed[data-current-step="form"] section[class*="_formContainer_"] {
          background: #fff !important;
          backdrop-filter: none !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #app-embed[data-current-step="form"],
        #app-embed[data-current-step="tease"] {
          transform: none !important;
        }

        #app-embed[data-current-step="form"] section[class*="_formContainer_"],
        #app-embed[data-current-step="tease"] section[class*="_formContainer_"] {
          transition: none !important;
          transform: none !important;
        }
      }
    `;

    const removePopupSocials = (shadowRoot) => {
      shadowRoot.querySelectorAll('[data-noir-discount-popup-socials]').forEach((socialNav) => {
        socialNav.remove();
      });
    };

    const resetManualFormScroll = (shadowRoot) => {
      if (!manualFormRequested || manualFormScrollSequence === manualFormOpenSequence) return;

      const formSurface = shadowRoot.querySelector(
        '#app-embed[data-current-step="form"] section[class*="_formContainer_"]'
      );
      if (!formSurface) return;

      manualFormScrollSequence = manualFormOpenSequence;
      const reset = () => {
        formSurface.scrollTop = 0;
        shadowRoot.querySelectorAll('#app-embed[data-current-step="form"] *').forEach((element) => {
          if (element.scrollTop > 0) element.scrollTop = 0;
        });
      };

      reset();
      window.requestAnimationFrame(reset);
      window.requestAnimationFrame(() => window.requestAnimationFrame(reset));
      window.setTimeout(reset, 160);
      window.setTimeout(reset, 600);
    };

    const stabilizeMobileFormGeometry = (shadowRoot) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const formSurface = shadowRoot.querySelector(
        '#app-embed[data-current-step="form"] section[class*="_formContainer_"]'
      );
      if (!formSurface) return;

      formSurface.style.setProperty('width', 'auto', 'important');
      formSurface.style.setProperty('left', '0.75rem', 'important');
      formSurface.style.setProperty('right', '0.75rem', 'important');
      formSurface.style.setProperty('max-width', 'none', 'important');
      formSurface.style.setProperty('height', 'auto', 'important');
      formSurface.style.setProperty('max-height', '64dvh', 'important');
      formSurface.style.setProperty('min-height', '0', 'important');
      formSurface.style.setProperty('overflow-y', 'auto', 'important');
      formSurface.style.setProperty('overscroll-behavior', 'contain', 'important');
      formSurface.style.setProperty('grid-template-rows', '112px auto', 'important');

      const imageItem = formSurface.children[0];
      const contentItem = formSurface.children[1];
      imageItem?.style.setProperty('height', '112px', 'important');
      imageItem?.style.setProperty('min-height', '0', 'important');
      imageItem?.style.setProperty('overflow', 'hidden', 'important');
      contentItem?.style.setProperty('min-height', '0', 'important');
      contentItem?.style.setProperty('overflow', 'visible', 'important');
      imageItem?.querySelector('img')?.style.setProperty('height', '100%', 'important');
      imageItem?.querySelector('img')?.style.setProperty('max-height', '100%', 'important');
    };

    const suppressAutomaticForm = (shadowRoot) => {
      if (manualFormRequested) return;

      const formEmbed = shadowRoot.querySelector('#app-embed[data-current-step="form"]');
      const closeButton = formEmbed?.querySelector('[class*="_formCloseButton_"]');
      closeButton?.click();
    };

    const neutralizeFormBackdrop = (shadowRoot) => {
      const formSurfaceSelector = 'section[class*="_formContainer_"]';
      const backdropMarkers = /overlay|backdrop|scrim|modal-backdrop/i;

      [...shadowRoot.querySelectorAll('*')].forEach((element) => {
        if (element.matches(`#app-embed, ${formSurfaceSelector}`) || element.closest(formSurfaceSelector)) return;

        const className = typeof element.className === 'string' ? element.className : '';
        const marker = `${element.id || ''} ${className} ${element.getAttribute('data-testid') || ''}`;
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const fillsViewport = rect.width >= window.innerWidth * 0.9 && rect.height >= window.innerHeight * 0.9;
        const isBackdrop = backdropMarkers.test(marker) || element.tagName === 'DIALOG' ||
          (fillsViewport && ['fixed', 'absolute'].includes(style.position));

        if (!isBackdrop) return;

        element.style.setProperty('background', 'transparent', 'important');
        element.style.setProperty('background-color', 'transparent', 'important');
        element.style.setProperty('box-shadow', 'none', 'important');
        element.style.setProperty('filter', 'none', 'important');
        element.style.setProperty('backdrop-filter', 'none', 'important');
        element.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });
    };

    const runBackdropCleanup = () => {
      let frames = 0;
      const cleanup = () => {
        document.querySelectorAll('shopify-forms-embed').forEach((host) => {
          if (host.shadowRoot) neutralizeFormBackdrop(host.shadowRoot);
        });
        frames += 1;
        if (frames < 45) window.requestAnimationFrame(cleanup);
      };

      cleanup();
    };

    const styleHost = (host) => {
      const shadowRoot = host.shadowRoot;
      if (!shadowRoot) return false;

      if (manualFormRequested) host.setAttribute('data-noir-discount-form-requested', 'true');

      if (!shadowRoot.querySelector('style[data-noir-discount-pill]')) {
        const style = document.createElement('style');
        style.setAttribute('data-noir-discount-pill', 'true');
        style.textContent = styleText;
        shadowRoot.appendChild(style);
      }

      if (!shadowRoot.__noirDiscountObserver) {
        shadowRoot.__noirDiscountObserver = new MutationObserver(() => {
          neutralizeFormBackdrop(shadowRoot);
          removePopupSocials(shadowRoot);
          suppressAutomaticForm(shadowRoot);
          stabilizeMobileFormGeometry(shadowRoot);
          resetManualFormScroll(shadowRoot);
        });
        shadowRoot.__noirDiscountObserver.observe(shadowRoot, {
          attributes: true,
          attributeFilter: ['data-current-step'],
          childList: true,
          subtree: true,
        });
      }

      neutralizeFormBackdrop(shadowRoot);
      removePopupSocials(shadowRoot);
      suppressAutomaticForm(shadowRoot);
      stabilizeMobileFormGeometry(shadowRoot);
      resetManualFormScroll(shadowRoot);

      return true;
    };

    const findTeaser = () => {
      const hosts = [...document.querySelectorAll('shopify-forms-embed')];
      hosts.forEach((host) => {
        if (manualFormRequested) host.setAttribute('data-noir-discount-form-requested', 'true');
        styleHost(host);
      });
      return hosts.map((host) => host.shadowRoot?.querySelector('[data-testid="form-teaser"]')).find(Boolean);
    };

    const openForm = (event) => {
      event.preventDefault();
      manualFormRequested = true;
      manualFormOpenSequence += 1;
      markSuggestionSeen();
      hideSuggestion();

      let attempts = 0;
      const openWhenReady = () => {
        const teaser = findTeaser();
        if (teaser) {
          teaser.click();
          runBackdropCleanup();
          return;
        }

        if (attempts >= 20) return;
        attempts += 1;
        window.setTimeout(openWhenReady, 250);
      };

      openWhenReady();
    };

    openButton.addEventListener('click', openForm);
    suggestionOpenButton.addEventListener('click', openForm);
    suggestionDismissButton.addEventListener('click', (event) => {
      event.preventDefault();
      markSuggestionSeen();
      hideSuggestion();
    });

    const pauseSuggestionAutoHide = () => {
      if (!suggestionVisible) return;

      refreshSuggestionCountdown(performance.now());
      suggestionInteractionActive = true;
      clearSuggestionAutoHideTimers();
    };

    const resumeSuggestionAutoHide = (event) => {
      if (!suggestionVisible) return;
      if (event?.relatedTarget && suggestion.contains(event.relatedTarget)) return;

      suggestionInteractionActive = false;
      startSuggestionAutoHide();
    };

    suggestion.addEventListener('pointerenter', pauseSuggestionAutoHide);
    suggestion.addEventListener('pointerleave', resumeSuggestionAutoHide);
    suggestion.addEventListener('focusin', pauseSuggestionAutoHide);
    suggestion.addEventListener('focusout', resumeSuggestionAutoHide);

    const handleScroll = () => {
      if (window.scrollY < scrollSuggestionThreshold) return;
      showSuggestion();
      window.removeEventListener('scroll', handleScroll);
    };

    if (!hasSeenSuggestion()) window.addEventListener('scroll', handleScroll, { passive: true });

    let attempts = 0;
    const applyStyles = () => {
      const hosts = [...document.querySelectorAll('shopify-forms-embed')];
      if (hosts.some(styleHost) || attempts >= 120) return;
      attempts += 1;
      window.setTimeout(applyStyles, 250);
    };

    applyStyles();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noir-promo-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-noir-bundle]');
    if (!root) return;

    const pill = root.querySelector('[data-noir-bundle-open]');
    const dialog = root.querySelector('[data-noir-bundle-dialog]');
    const closeButton = root.querySelector('[data-noir-bundle-close]');
    const image = root.querySelector('[data-noir-bundle-image]');
    const imageLink = root.querySelector('[data-noir-bundle-image-link]');
    const sources = [...root.querySelectorAll('[data-noir-bundle-source]')]
      .map((source) => ({ src: source.dataset.src, alt: source.dataset.alt, href: source.dataset.href }))
      .filter((source) => source.src);
    const timerProgress = dialog?.querySelector('.noir-bundle__timer-progress');
    if (!pill || !dialog || !closeButton || !image || !imageLink || !sources.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopHoverMedia = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
    const closeMorphDuration = reducedMotion ? 0 : 240;
    const closeFadeDuration = reducedMotion ? 120 : 80;
    const autoCloseDuration = 10000;
    const timerCircumference = 119.38;
    const autoShownKey = 'noir-bundle-auto-shown-v1';
    const previewMode = new URLSearchParams(window.location.search).has('promo-preview');
    let closeMorphTimer;
    let closeFadeTimer;
    let closeFallbackTimer;
    let autoCloseTimer;
    let countdownFrame;
    let closeFinalizeFrame;
    let handoffToken = 0;
    let shouldReturnFocus = false;
    let currentImageIndex = -1;

    const chooseImage = () => {
      if (sources.length === 1) {
        currentImageIndex = 0;
      } else {
        let nextIndex = Math.floor(Math.random() * sources.length);
        if (nextIndex === currentImageIndex) nextIndex = (nextIndex + 1) % sources.length;
        currentImageIndex = nextIndex;
      }

      const nextImage = sources[currentImageIndex];
      image.src = nextImage.src;
      image.alt = nextImage.alt || '';
      imageLink.href = nextImage.href || pill.dataset.bundleUrl;
      imageLink.setAttribute('aria-label', nextImage.alt || pill.getAttribute('aria-label'));
      if (nextImage.href) pill.dataset.bundleUrl = nextImage.href;
    };

    const preloadImages = () => {
      sources.forEach((source) => {
        const preloader = new Image();
        preloader.src = source.src;
      });
    };

    const hasAutoShown = () => {
      try {
        return window.sessionStorage.getItem(autoShownKey) === '1';
      } catch (error) {
        return false;
      }
    };

    const markAutoShown = () => {
      try {
        window.sessionStorage.setItem(autoShownKey, '1');
      } catch (error) {
        return;
      }
    };

    const stopCountdown = () => {
      if (countdownFrame) window.cancelAnimationFrame(countdownFrame);
      countdownFrame = undefined;
    };

    const clearPillHandoff = () => {
      handoffToken += 1;
      if (closeFinalizeFrame) window.cancelAnimationFrame(closeFinalizeFrame);
      closeFinalizeFrame = undefined;
      root.classList.remove('is-pill-handoff');
    };

    const startCountdown = () => {
      if (!timerProgress || reducedMotion) return;

      const startedAt = window.performance.now();
      const updateCountdown = (now) => {
        const progress = Math.min((now - startedAt) / autoCloseDuration, 1);
        timerProgress.style.strokeDashoffset = String((progress * timerCircumference).toFixed(2));

        if (progress < 1) {
          countdownFrame = window.requestAnimationFrame(updateCountdown);
        }
      };

      countdownFrame = window.requestAnimationFrame(updateCountdown);
    };

    const completeClose = () => {
      if (!dialog.open || !dialog.classList.contains('is-closing-final')) return;

      window.clearTimeout(closeMorphTimer);
      window.clearTimeout(closeFadeTimer);
      window.clearTimeout(closeFallbackTimer);
      closeMorphTimer = undefined;
      closeFadeTimer = undefined;
      closeFallbackTimer = undefined;

      const token = ++handoffToken;
      root.classList.add('is-pill-handoff');
      root.classList.remove('is-dialog-open');

      closeFinalizeFrame = window.requestAnimationFrame(() => {
        closeFinalizeFrame = window.requestAnimationFrame(() => {
          if (
            token !== handoffToken ||
            !dialog.open ||
            root.classList.contains('is-dialog-open')
          ) {
            closeFinalizeFrame = undefined;
            return;
          }

          dialog.close();
          closeFinalizeFrame = window.requestAnimationFrame(() => {
            if (
              token === handoffToken &&
              !dialog.open &&
              !root.classList.contains('is-dialog-open')
            ) {
              root.classList.remove('is-pill-handoff');
            }
            closeFinalizeFrame = undefined;
          });
        });
      });
    };

    const closeDialog = () => {
      if (
        !dialog.open ||
        dialog.classList.contains('is-closing') ||
        dialog.classList.contains('is-closing-final')
      ) return;

      dialog.classList.remove('is-open', 'is-closing-final');
      dialog.classList.add('is-closing');
      dialog.classList.remove('is-counting');
      stopCountdown();
      window.clearTimeout(closeMorphTimer);
      window.clearTimeout(closeFadeTimer);
      window.clearTimeout(closeFallbackTimer);
      window.clearTimeout(autoCloseTimer);

      const fadeStart = Math.max(0, closeMorphDuration - closeFadeDuration);
      closeMorphTimer = window.setTimeout(() => {
        if (!dialog.open || !dialog.classList.contains('is-closing')) return;

        dialog.classList.add('is-closing-final');
        root.classList.add('is-pill-handoff');
        root.classList.remove('is-dialog-open');
        closeMorphTimer = undefined;

        if (reducedMotion || !desktopHoverMedia.matches) {
          closeFadeTimer = window.setTimeout(completeClose, closeFadeDuration);
        } else {
          // transitionend is the primary completion signal. This is only a
          // safety net for browsers that do not report clip-path transitions.
          closeFallbackTimer = window.setTimeout(
            completeClose,
            closeFadeDuration + 80
          );
        }
      }, fadeStart);
    };

    const openDialog = (event, shouldFocus = true, autoDismiss = false) => {
      if (!dialog.show) {
        window.location.assign(pill.dataset.bundleUrl);
        return;
      }

      event?.preventDefault();
      const wasClosing = dialog.classList.contains('is-closing') || dialog.classList.contains('is-closing-final');
      window.clearTimeout(closeMorphTimer);
      window.clearTimeout(closeFadeTimer);
      window.clearTimeout(closeFallbackTimer);
      window.clearTimeout(autoCloseTimer);
      clearPillHandoff();
      dialog.classList.remove('is-closing', 'is-closing-final');
      dialog.classList.toggle('is-reopening', wasClosing);
      dialog.classList.remove('is-counting');
      stopCountdown();
      chooseImage();
      if (timerProgress) {
        timerProgress.style.strokeDashoffset = '0';
        timerProgress.getBoundingClientRect();
      }
      root.classList.add('is-dialog-open');
      if (autoDismiss) markAutoShown();
      shouldReturnFocus = shouldFocus;
      if (!dialog.open) dialog.show();
      window.requestAnimationFrame(() => {
        dialog.classList.add('is-open');
        if (shouldFocus) {
          closeButton.focus({ preventScroll: true });
        } else if (document.activeElement === closeButton) {
          closeButton.blur();
        }
      });

      if (autoDismiss) {
        dialog.classList.add('is-counting');
        startCountdown();
        autoCloseTimer = window.setTimeout(closeDialog, autoCloseDuration);
      }
    };

    const revealBundle = () => {
      root.classList.add('is-ready');
      if (!desktopHoverMedia.matches && (previewMode || !hasAutoShown())) {
        window.requestAnimationFrame(() => openDialog(null, false, true));
      } else if (desktopHoverMedia.matches && root.matches(':hover')) {
        window.requestAnimationFrame(() => openDialog(null, false, false));
      }
    };

    const handleDesktopPointerEnter = () => {
      if (!desktopHoverMedia.matches || !root.classList.contains('is-ready')) return;
      openDialog(null, false, false);
    };

    const handleDesktopPointerLeave = (event) => {
      if (!desktopHoverMedia.matches) return;

      const nextTarget = event.relatedTarget;
      if (nextTarget && root.contains(nextTarget)) return;
      closeDialog();
    };

    chooseImage();
    preloadImages();
    document.addEventListener('noir:boot-screen-finished', revealBundle, { once: true });

    if (!document.documentElement.classList.contains('noir-booting')) {
      revealBundle();
    } else {
      window.setTimeout(() => {
        if (!document.documentElement.classList.contains('noir-booting')) revealBundle();
      }, 3600);
    }

    root.addEventListener('pointerenter', handleDesktopPointerEnter);
    root.addEventListener('pointerleave', handleDesktopPointerLeave);

    pill.addEventListener('click', (event) => {
      const desktopPointerActivation = desktopHoverMedia.matches && event.detail > 0;
      openDialog(event, !desktopPointerActivation, !desktopHoverMedia.matches);
    });
    closeButton.addEventListener('click', closeDialog);

    dialog.addEventListener('transitionend', (event) => {
      if (
        event.target !== dialog ||
        event.propertyName !== 'clip-path' ||
        !dialog.classList.contains('is-closing-final')
      ) return;

      completeClose();
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      window.clearTimeout(closeMorphTimer);
      window.clearTimeout(closeFadeTimer);
      window.clearTimeout(closeFallbackTimer);
      window.clearTimeout(autoCloseTimer);
      dialog.classList.remove('is-open', 'is-closing', 'is-closing-final', 'is-reopening');
      dialog.classList.remove('is-counting');
      stopCountdown();
      root.classList.remove('is-dialog-open');
      if (shouldReturnFocus) pill.focus({ preventScroll: true });
      shouldReturnFocus = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
